export enum LeaveTypeIdEn {
  COMPENSATORY_LEAVE = 2
}
